/*jshint esversion: 6 */

// polyfills, etc
require('babel-polyfill');
require('es6-promise').polyfill();
const originalFetch = require('isomorphic-fetch');
require('fetch-retry')(originalFetch);
require('../../../../Foundation/ReactForms/Code/Scripts/date-input-polyfill.dist.js');

// ASAWEB-864: screen every request (fetch + XHR) for a literal "/undefined"
// segment before any feature code can fire one. Installed once per bundle.
require('../../../../Foundation/ReactForms/Code/Scripts/React/fetchWithAuth.jsx').installGlobalUrlGuard();

// Foundation ========================================================= *
import common from '../../../../Foundation/Common/code/Scripts/common.js';

// analytics
import analytics from '../../../../Foundation/Analytics/code/Scripts/Analytics.js';

// Content
import content from '../../../../Foundation/Content/code/Scripts/content.js';

// Features ========================================================= *

// Widgets
import widget from '../../../../Feature/Widget/code/Scripts/Widget.js';
// Navigation
import navigation from '../../../../Feature/Navigation/code/Scripts/navigation.js';
// Events
import events from '../../../../Feature/Events/code/Scripts/events.js';
// Cart count is rendered on every page via BaseLayout — always bootstrap it
import cartCountBootstrapper from '../../../../Feature/Shop/code/Scripts/cartCountBootstrapper.jsx';
// HomePage
import homepage from '../../../../Feature/HomePage/code/Scripts/HomePage.js';
// Seo
import seo from '../../../../Feature/Seo/code/Scripts/Seo.js';
// Notifications
import notifications from '../../../../Feature/Notifications/code/Scripts/Notifications.js';

// microsite
import microsite from '../../../../Project/MainSite/code/Scripts/micrositeUtils.js';

// Utils
import utils from '../../../../Project/MainSite/code/Scripts/mainsiteUtils.js';
// Spotlight
import spotlight from '../../../../Feature/Spotlight/code/Scripts/Spotlight.js';

// Conditional feature bundles — only downloaded/parsed when the page actually uses them

if (document.querySelector('.CoveoSearchInterface')) {
    import(/* webpackChunkName: "search" */ '../../../../Feature/Search/code/Scripts/search.js');
}

// Gate on a purpose-built [data-bundle="shop"] hook emitted by the shop feature
// partials (add-to-cart, long description, course callouts, related products, gallery,
// missing-product modal) rather than incidental styling classes.
if (document.querySelector('[data-bundle="shop"]')) {
    import(/* webpackChunkName: "shop" */ '../../../../Feature/Shop/code/Scripts/shop.js');
}

if (document.querySelector('.event-submission-button, .event-submission-form')) {
    import(/* webpackChunkName: "forms" */ '../../../../Feature/Forms/code/Scripts/Forms.js');
}

if (document.querySelector('.FOP-panel, #areas-of-interest-save')) {
    import(/* webpackChunkName: "higherlogic" */ '../../../../Feature/HigherLogic/code/Scripts/higherlogic.js');
}

if (document.querySelector('.transcripts-panel')) {
    import(/* webpackChunkName: "my-account" */ '../../../../Feature/Account/code/Scripts/myAccount.js');
}
